import ajaxCrud from "./ajaxCrud";
import { endpointMacchinaStreaming } from "../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointMacchinaStreaming, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointMacchinaStreaming, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointMacchinaStreaming, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointMacchinaStreaming, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointMacchinaStreaming, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointMacchinaStreaming, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointMacchinaStreaming, rows, cb);
  },
};
